import { MetaTagsProps, SubCategory } from "@/types";
import { content } from "./content";
import { images } from "./images";
import { OG_PATH } from "@/content";
import {
  createImageItems,
  createServicePoints,
} from "@/content/services/service-content-helpers";

const slug = "data-infrastructure-security-cabling-sydney";
const serviceId = 5;

export const createMetaTags = (
  parentMetaTags: MetaTagsProps,
): { metaTags: MetaTagsProps; slug: string } => {
  const metaTags: MetaTagsProps = {
    title: "Data Infrastructure & Security Cabling Sydney | Ozy Wide Group",
    description:
      "Structured cabling for CCTV, alarms, intercoms, access control and integrated security systems.",
    keywords:
      "security cabling Sydney, data infrastructure, structured cabling, CCTV cabling, alarm cabling, access control cabling",
    url: `${parentMetaTags.url.replace(/\/$/, "")}/${slug}/`,
    ogImage: `${OG_PATH}service-${slug}.jpg`,
    type: "website",
  };

  return { metaTags, slug };
};

export const category: Omit<SubCategory, "headCategory" | "slug" | "metaTags"> =
  {
    id: serviceId,
    title: "Data Infrastructure & Security Cabling",
    description:
      "Structured cabling for CCTV, alarms, intercoms, access control and integrated security systems.",
    points: createServicePoints(
      "Cable routes and device positions planned",
      "Security devices supported with neat cabling",
      "Future maintenance and labelling considered",
    ),
    images: createImageItems(
      images,
      "Data Infrastructure & Security Cabling Sydney",
    ),
    content,
  };
